import axios from '../utils/axios';

class WebhookService {
  /**
   * Test a webhook URL
   */
  async testWebhook(url) {
    try {
      const response = await axios.post('/webhooks/test', { url });
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Validate a webhook URL
   */
  async validateWebhook(url) {
    try {
      const response = await axios.post('/webhooks/validate', { url });
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Get webhook delivery statistics
   */
  async getStatistics(filters = {}, options = {}) {
    try {
      const config = { params: filters };
      // Add cache control headers if cache is disabled
      if (options.cache === false) {
        config.headers = { 'Cache-Control': 'no-cache' };
      }
      const response = await axios.get('/webhooks/statistics', config);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Get webhook deliveries with pagination
   */
  async getDeliveries(params = {}) {
    try {
      const response = await axios.get('/webhooks/deliveries', { params });
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Get webhook delivery history for an evaluation result
   */
  async getDeliveryHistory(evaluationResultId) {
    try {
      const response = await axios.get(`/webhooks/history/${evaluationResultId}`);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Retry a failed webhook delivery
   */
  async retryDelivery(deliveryId) {
    try {
      const response = await axios.post(`/webhooks/deliveries/${deliveryId}/retry`);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Get webhook delivery details
   */
  async getDeliveryDetails(deliveryId) {
    try {
      const response = await axios.get(`/webhooks/deliveries/${deliveryId}`);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Create a new webhook endpoint
   */
  async createWebhookEndpoint(data) {
    try {
      const response = await axios.post('/webhook-endpoints', data);
      // Clear webhook endpoints cache after creating
      // Note: This would need to be handled by the service that uses this
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Get webhook endpoints with pagination
   */
  async getWebhookEndpoints(params = {}, options = {}) {
    try {
      const config = { params };
      // Add cache control headers if cache is disabled
      if (options.cache === false) {
        config.headers = { 'Cache-Control': 'no-cache' };
      }
      const response = await axios.get('/webhook-endpoints', config);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Delete a webhook endpoint
   */
  async deleteWebhookEndpoint(id) {
    try {
      const response = await axios.delete(`/webhook-endpoints/${id}`);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Handle API errors consistently
   */
  handleError(error) {
    const message = error.response?.data?.message || error.message || 'An error occurred';
    const status = error.response?.status || 500;

    console.error('Webhook API Error:', {
      message,
      status,
      url: error.config?.url,
      method: error.config?.method,
    });

    return {
      success: false,
      error: message,
      status,
    };
  }
}

const webhookService = new WebhookService();
export default webhookService;
